// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroller{overflow-y:auto}.droppercard{border:dashed #d3d3d3;max-width:60%;margin:auto!important;border-radius:12px}.tooltip .tooltip-inner{max-width:250px!important;width:200px!important}", ""]);
// Exports
module.exports = exports;
